/*
 * 5-М6 «Отпроситься» — числа из макета «Доступы, вебхуки, печать - П2»: экран 360,
 * поля 16, зазор 12; причины — чипы высотой 40; даты — поля 48; цена просьбы — карточка
 * радиусом 12 с отступом 12 × 14; кнопка внизу на всю ширину, 48, радиус 12.
 */

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  padding: 4px 16px 12px;
  overflow-y: auto;
  font-size: 12.5px;
  line-height: 1.5;
}

.title {
  margin: 0;
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
}

.sub {
  font-size: 11.5px;
  color: var(--text-secondary);
}

.label {
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
}

.reason {
  min-height: 40px;
}

.dates {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.date {
  display: flex;
  flex-direction: column;
}

.date input {
  height: 48px;
  padding: 0 12px;
  font: inherit;
  font-size: 14px;
  color: var(--text-primary);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 10px;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.cardTitle {
  font-weight: var(--font-weight-semibold);
}

.clients {
  font-weight: var(--font-weight-semibold);
  color: var(--status-pending-fg);
}

.variant {
  padding: 10px 12px;
  color: var(--hold-quarantine-fg);
  background: var(--hold-quarantine-bg);
  border-radius: 12px;
}

.variant b {
  font-weight: var(--font-weight-semibold);
}

.problem {
  padding: 10px 12px;
  color: var(--danger-hover);
  background: var(--status-no-show-bg);
  border-radius: 12px;
}

.sentHead {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
}

.note {
  font-size: 12px;
  color: var(--text-secondary);
}

.footer {
  flex: none;
  padding: 8px 16px 12px;
  border-top: 1px solid var(--border);
}

.send {
  width: 100%;
  min-height: 48px;
  font-size: 14px;
  border-radius: 12px;
}
